import { type IColumn, Icon, Typography } from 'shared/ui'
import { EmptyCell } from 'shared/ui/TableNew'
import { InboxCell } from 'entities/Inbox/ui/InboxCell/InboxCell.tsx'
import { type FrontChannelRow } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationFrontSettings/store/IntegrationFrontSettingsStore.ts'
import styles from './styles.module.scss'

export const columns: IColumn<FrontChannelRow>[] = [
  {
    field: 'front_inbox',
    name: 'Front inbox',
    renderRowCell: (row) =>
      row.origin.front_inbox ? (
        <div className={styles.row}>
          <Icon icon={'front'} />
          <Typography
            ellipsis
            tag='div'
            variant={'body-md-regular'}
            tooltipProps={{
              label: row.origin.front_inbox.name,
              placement: 'top',
              fullWidth: true,
              maxWidth: '445px',
            }}
            ariaLabel='restrictedWord'
          >
            {row.origin.front_inbox?.name}
          </Typography>
        </div>
      ) : (
        <EmptyCell />
      ),
  },
  {
    field: 'salesmsg_inbox',
    name: 'Salesmsg inbox',
    renderRowCell: (row) => {
      return row.origin.salesmsg_inbox ? (
        <InboxCell name={row.origin.salesmsg_inbox?.name} id={row.origin.salesmsg_inbox?.id} />
      ) : (
        <EmptyCell />
      )
    },
  },
  {
    field: 'number',
    name: 'Number',
    renderRowCell: (row) =>
      row.origin.number ? row.origin.number.formatted_number : <EmptyCell />,
  },
]
